module.exports = __webpack_public_path__ + "static/media/dog-correct.5f65510e.gif";